'use client'
import { createTheme } from '@mui/material'

export const lightTheme = createTheme({
  palette: {
    primary: {
      main: '#7058E7'
    },
    secondary: {
      main: '#F5F5F5'
    },
    mode: 'light'
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#5C5E6A',
          color: '#F5F5F5'
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#F5F5F5',
          '&.Mui-selected': {
            fontweight: 'bold'
          }
        }
      }
    }
  }
})

// 新デザインを適用した画面にだけ被せるテーマで、既存画面は lightTheme のまま
export const ipDashboardTheme = createTheme(lightTheme, {
  palette: {
    // --accent
    primary: {
      main: '#111111',
      contrastText: '#FFFFFF'
    },
    // --danger / --ok
    error: {
      main: '#B74040'
    },
    success: {
      main: '#3F8A5B'
    },
    // --bg / --surface
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF'
    },
    // --text / --text-2 / --text-3
    text: {
      primary: '#1A1A1A',
      secondary: '#6B6B6B',
      disabled: '#9A9A9A'
    },
    // --border
    divider: '#E5E5E5',
    // --surface-2 / --surface-3 / --border-strong
    grey: {
      100: '#F5F5F5',
      200: '#EFEFEF',
      300: '#D4D4D4'
    }
  }
})

export const darkTheme = createTheme({
  palette: {
    mode: 'dark'
  }
})
